/**
 * Teens Product Slider — horizontal card slider ONLY
 * --------------------------------------------------
 * Selectors used by this file (unique to product slider):
 *   [data-teens-product-slider]   — root wrap
 *   [data-product-slider-swiper]  — .swiper element
 *   [data-product-slider-prev]
 *   [data-product-slider-next]
 *   [data-product-slider-pagination]
 *
 * theme.liquid (Swiper CDN already there):
 *   <script src="{{ 'prod-slider.js' | asset_url }}" defer></script>
 */
(function () {
  'use strict';

  var ROOT = '[data-teens-product-slider]';
  var retries = 0;

  function toNumber(value, fallback) {
    var n = Number(value);
    return isFinite(n) && n > 0 ? n : fallback;
  }

  function initOne(root) {
    if (!root || root.getAttribute('data-product-slider-ready') === 'true') return;
    if (typeof Swiper === 'undefined') return;

    var slider = root.querySelector('[data-product-slider-swiper]');
    if (!slider) return;

    if (slider.swiper && !slider.swiper.destroyed) {
      slider.swiper.destroy(true, true);
    }

    var desktopSlides = toNumber(root.getAttribute('data-desktop-slides'), 3);
    var desktopGap = toNumber(root.getAttribute('data-desktop-gap'), 24);

    new Swiper(slider, {
      direction: 'horizontal',
      effect: 'slide',
      slidesPerView: 1.2,
      slidesPerGroup: 1,
      spaceBetween: 16,
      speed: 500,
      loop: false,
      rewind: true,
      autoHeight: true,
      watchOverflow: true,
      grabCursor: true,
      simulateTouch: true,
      allowTouchMove: true,
      navigation: {
        nextEl: root.querySelector('[data-product-slider-next]'),
        prevEl: root.querySelector('[data-product-slider-prev]'),
      },
      pagination: {
        el: root.querySelector('[data-product-slider-pagination]'),
        clickable: true,
      },
      breakpoints: {
        750: {
          slidesPerView: 2,
          spaceBetween: 20,
          autoHeight: false,
        },
        990: {
          slidesPerView: desktopSlides,
          spaceBetween: desktopGap,
          autoHeight: false,
        },
      },
    });

    root.setAttribute('data-product-slider-ready', 'true');
  }

  function initAll(scope) {
    var parent = scope && scope.querySelectorAll ? scope : document;
    var roots = parent.querySelectorAll(ROOT);

    if (scope && scope.matches && scope.matches(ROOT)) {
      initOne(scope);
    }

    Array.prototype.forEach.call(roots, initOne);
  }

  function destroyIn(scope) {
    if (!scope || !scope.querySelectorAll) return;
    var roots = scope.querySelectorAll(ROOT);

    Array.prototype.forEach.call(roots, function (root) {
      var slider = root.querySelector('[data-product-slider-swiper]');
      if (slider && slider.swiper && !slider.swiper.destroyed) {
        slider.swiper.destroy(true, true);
      }
      root.removeAttribute('data-product-slider-ready');
    });
  }

  function boot() {
    if (typeof Swiper === 'undefined') {
      if (retries < 60) {
        retries += 1;
        setTimeout(boot, 50);
      }
      return;
    }
    retries = 0;
    initAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var target = event.target;
    if (!target) return;
    // Allow re-init after theme editor reload
    var roots = target.querySelectorAll
      ? target.querySelectorAll(ROOT)
      : [];
    Array.prototype.forEach.call(roots, function (root) {
      root.removeAttribute('data-product-slider-ready');
    });
    if (target.matches && target.matches(ROOT)) {
      target.removeAttribute('data-product-slider-ready');
    }
    initAll(target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroyIn(event.target);
  });
})();
